module.exports = __webpack_public_path__ + "static-v-shop/1791259744883/img/logo_visa.5f04499f.svg";